import { render, staticRenderFns } from "./SingleArticle.vue?vue&type=template&id=63c46f60&scoped=true&lang=pug&"
import script from "./SingleArticle.vue?vue&type=script&lang=js&"
export * from "./SingleArticle.vue?vue&type=script&lang=js&"
import style0 from "./SingleArticle.vue?vue&type=style&index=0&id=63c46f60&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c46f60",
  null
  
)

export default component.exports